/* eslint-disable quotes */
import { faGithub } from "@fortawesome/free-brands-svg-icons/faGithub";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons/faEnvelope";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: "https://github.com/mldangelo",
    label: "Github",
    icon: faGithub,
  },
  {
    link: "https://www.instagram.com/a.azhhar?igsh=MXN2bTd6OGMxbDE0aQ",
    label: "Instagram",
    icon: faInstagram,
  },
  {
    link: "https://www.linkedin.com/in/azxaar/",
    label: "LinkedIn",
    icon: faLinkedinIn,
  },
  {
    link: "https://x.com/azhara501947789?s=21x.com",
    label: "X",
    icon: faXTwitter,
  },
  {
    link: "mailto:azhar89143@gmail.com",
    label: "Email",
    icon: faEnvelope,
  },
];

export default data;
